/* eslint-disable */

require('jquery-validation');

var $                 = require('jquery');
var ValidationHelpers = require('./form-validation-helper');

var FORMS             = '.js-formValidateAjaxSubmit';

module.exports = function() { /* Nothing to Export */ };


$(document).ready(function() {
    $(FORMS).each(function(){
        let $FORM = $(this);

        $FORM.validate({

            // Localize
            lang: $('html').attr('lang') || 'en',

            // On Validation, submit the form
            submitHandler: function(form) {


                var $validatedForm       = $(form);
                var ajaxAction           = $validatedForm.attr('data-ajax-action') || $validatedForm.attr('action');

                var redirect_success_url = $validatedForm.data('redirect-success-url'); // optional
                var redirect_failure_url = $validatedForm.data('redirect-failure-url'); // optional

                var ga_event_category    = $validatedForm.data('ga-event-category');    // optional
                var ga_event_action      = $validatedForm.data('ga-event-action');      // optional
                var ga_event_label       = $validatedForm.data('ga-event-label');       // optional

                // Abort when misconfigured
                if (!ajaxAction) {
                    console.log('data-ajax-action missing.');

                    return;
                }


                // Start "loading" state (e.g. spinner)
                ValidationHelpers.setLoading($validatedForm, true);

                // Perform AJAX request
                var formXHR = $.ajax({
                    url:         ajaxAction,
                    type:        'post',
                    data:        new FormData(form),
                    cache:       false,
                    contentType: false,
                    processData: false
                });


                formXHR.done(function(resp) {
                    if (typeof resp.success === 'undefined') {
                        // Out of bounds
                    }
                    else {
                        // Send GA Event (if requested)
                        if (typeof ga === 'function' && ga_event_category && ga_event_action) {
                            ga('send', 'event', ga_event_category, ga_event_action, ga_event_label);
                        }


                        // Redirect if AJAX response provides a "redirect value"
                        if (typeof resp.data.redirect !== 'undefined' && resp.data.redirect != null) {
                            window.location.href = resp.data.redirect;
                        }

                        // Redirect if the form data attributes provide a "redirect-success-url"
                        else if (redirect_success_url) {
                            window.location.href = redirect_success_url;
                        }

                        // Otherwise, display a "Success Message" on-page
                        else {
                            ValidationHelpers.showMessage( $validatedForm, resp.data.message, resp.success);
                            $validatedForm.find('.form__submit').hide();

                            if ($validatedForm.data('form-hide-on-success')) {
                                $validatedForm.find('>:not(.form__response)').hide();

                                // Scroll the message into view
                                $('html, body').animate({
                                    scrollTop: $validatedForm.find('.form__response').offset().top
                                }, 1000);
                            }
                        }
                    }

                });

                /*
                 * Ajax request failed, either in transport or the application threw a 500 error.
                 */
                formXHR.fail(function(jqXHR, textStatus, errorThrown) {
                    // Ajax Error
                    if (redirect_failure_url) {
                        window.location.href = redirect_failure_url;
                    }
                    else {
                        var appErrorMessage = JSON.parse(jqXHR.responseText).data.message;

                        if (!appErrorMessage) appErrorMessage = errorThrown;
                        ValidationHelpers.showMessage( $validatedForm, appErrorMessage, false);
                    }

                    // Reset the reCAPTCHA (if present)
                    if (window.grecaptcha) grecaptcha.reset();
                });


                formXHR.always(function() {
                    // Stop "loading" state (e.g. spinner)
                    ValidationHelpers.setLoading( $validatedForm, false);
                });

            }

        });


        /*
         * This helper method prepares messages for the validator.
         * It MUST be loaded after the validator is loaded.
         */
        ValidationHelpers.loadFormMessages($FORM);

    });

});
